<template>
    <div id="water-print-drop" @click="waterPrintStatus">
        <svg width="42" height="42" class="desktop">
            <circle cx="21" cy="21" r="19" fill="none" stroke="white" stroke-width="2px" stroke-dasharray="0"
                    stroke-dashoffset="360"/>
            <circle class="blue-circle" cx="21" cy="21" r="19" fill="none" stroke="#00a0e2" stroke-width="4px"
                    :stroke-dasharray="computedDashArray"
                    :stroke-dashoffset="360"/>
        </svg>
        <svg class="mobile">
            <circle cx="50%" cy="50%" r="45%" fill="none" stroke="white" stroke-width="2px" stroke-dasharray="0"
                    stroke-dashoffset="360"/>
            <circle class="blue-circle" cx="50%" cy="50%" r="45%" fill="none" stroke="#00a0e2" stroke-width="4px"
                    stroke-dasharray="0"
                    stroke-dashoffset="360"/>
        </svg>
        <img src="@/assets/img/icons/white-drop.svg">
    </div>
</template>

<script>
    import EventBus from "../main";

    export default {
        name: "WaterPrintDrop",
        data() {
            return {
                dashDifference: 40
            }
        },
        props: ['waterPrintIndex', 'waterPrintLength'],
        computed: {
            computedDashArray() {
                return 120 + ((40 / (this.waterPrintLength - 1)) * this.waterPrintIndex);
            }
        },
        methods: {
            waterPrintStatus() {
                EventBus.$emit('water-print-status');
            }
        },
        created() {
            EventBus.$on('water-print-data', (data) => {
                this.dashTotalLength = data;
            });
        }
    }
</script>

<style lang="scss">
    #water-print-drop {
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10;
        margin-top: 15px;
        width: 42px;
        height: 42px;
        cursor: pointer;

        @media only screen and (max-device-width: 768px) {
            width: 100px;
            height: 100px;
            position: relative;
        }

        svg {
            position: absolute;
            left: 50%;
            transform: translateX(-50%);

            &.desktop {
                display: block;
            }

            &.mobile {
                display: none;
                width: 100%;
                height: 100%;
            }

            .blue-circle {
                transform-origin: center;
                transform: rotate(-90deg);
                transition: stroke-dasharray 250ms ease-in-out;
            }

            @media only screen and (max-device-width: 768px) {
                &.mobile {
                    display: block;
                }
                &.desktop {
                    display: none;
                }
            }
        }

        img {
            width: 16px;
            height: 26px;

            @media only screen and (max-device-width: 768px) {
                width: auto;
                height: 55%;
                object-fit: contain;
            }
        }
    }
</style>